export const isDevelopmentEnv = (): boolean => {
    const hostname = window.location.hostname;

    return hostname === 'localhost' || hostname.indexOf('prezi.dev') > -1;
};



// WEBPACK FOOTER //
// ./assets/js/utils.ts